import { FC, useState } from 'react'
import { Button, Icon, Tooltip, Modal } from 'antd'
import { joinClassNames } from '@signifyd/legacy-components'
import './DenylistBtn.less'

export type DenyListButtonProps = {
  type: keyof typeof DENYLIST_ITEMS
  denylisted: boolean
  loading: boolean
  onConfirm: () => void
}

const DENYLIST_ITEMS = {
  CONFIRMATION_EMAIL: {
    TOOLTIP: 'Denylist Confirmation Email',
    CONFIRM_MSG: 'Are you sure you want to denylist this Confirmation Email?',
    ICON: 'mail',
  },
  DELIVERY_ADDRESS: {
    TOOLTIP: 'Denylist Delivery Address',
    CONFIRM_MSG: 'Are you sure you want to denylist this Delivery Address?',
    ICON: 'home',
  },
}

const DenylistBtn: FC<DenyListButtonProps> = ({
  type,
  denylisted,
  loading,
  onConfirm,
}) => {
  const [modalVisible, setModalVisible] = useState(false)
  const { TOOLTIP, ICON, CONFIRM_MSG } = DENYLIST_ITEMS[type]

  const handleOk = () => {
    if (denylisted) {
      return
    }

    setModalVisible(false)
    onConfirm()
  }

  return (
    <Tooltip title={TOOLTIP}>
      <Button
        className={joinClassNames([
          'DenylistBtn',
          denylisted && 'DenylistBtn--denylisted',
        ])}
        type="primary"
        loading={loading}
        onClick={() => !denylisted && setModalVisible(true)}
        size="small"
        data-test-id={`denyListButton-${denylisted ? 'Disabled' : 'Enabled'}`}
      >
        {!loading && (
          <Icon data-test-id={`denyListButton-icon-${ICON}`} type={ICON} />
        )}
      </Button>
      {!denylisted && (
        <Modal
          okText="Yes"
          cancelText="No"
          visible={modalVisible}
          onOk={handleOk}
          onCancel={() => setModalVisible(false)}
        >
          <h6>{CONFIRM_MSG}</h6>
        </Modal>
      )}
    </Tooltip>
  )
}

export default DenylistBtn
